export default {
  _not_interested_in_this_video: 'Pas intéressé par cette vidéo? %second%',
  _switch_one: 'Une autre',
}